var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "help-me-write" }, [
    _c(
      "div",
      [
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c("h3", { staticClass: "font-outfit-medium" }, [
            _vm._v(
              " " + _vm._s(_vm.infoTexts.title || _vm.$t("yourContent")) + " "
            ),
          ]),
          _c("p", { staticClass: "help-me-write-description" }, [
            _vm._v(" " + _vm._s(_vm.$t("aiBuddyHelpsYouWrite")) + " "),
          ]),
        ]),
        _c(
          "el-row",
          { attrs: { gutter: 50 } },
          [
            _c("el-col", { attrs: { xl: 12 } }, [
              _c(
                "div",
                { staticClass: "mb-5" },
                [
                  _c("jodit-editor", {
                    attrs: {
                      config: _vm.joditEditorConfig,
                      buttons: _vm.joditEditorButtons,
                    },
                    model: {
                      value: _vm.content,
                      callback: function ($$v) {
                        _vm.content = $$v
                      },
                      expression: "content",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-row justify-content-between jodit-counter-wrapper",
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "disclaimer-text font-outfit-light" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.contentLength) +
                              " / " +
                              _vm._s(_vm.charactersLimit) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "p",
                        { staticClass: "disclaimer-text font-outfit-light" },
                        [_vm._v(" " + _vm._s(_vm.$t("dragToExpand")) + " ")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c("el-col", { attrs: { xl: 12 } }, [
              _c(
                "div",
                { staticClass: "handwriting-wrapper relative" },
                [
                  _c("ai-help-me-write-generated-content", {
                    attrs: { type: _vm.type },
                    on: {
                      replaceContent: function ($event) {
                        _vm.content = $event
                      },
                    },
                  }),
                  _vm.getHandwritingVisible("aiHelpMeWrite")
                    ? _c("AddDialogAiHandwriting", {
                        staticClass: "generate-handwriting",
                        attrs: { "direction-down": "", reverse: false },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "d-flex justify-content-start" }, [
                _c("p", { staticClass: "disclaimer-text font-outfit-light" }, [
                  _vm._v(" " + _vm._s(_vm.$t("aiDisclaimer")) + " "),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _c("v-divider"),
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-column flex-md-row justify-content-end align-items-center help-me-write-footer",
          },
          [
            _c("ai-buddy-request-remaining"),
            _c(
              "div",
              { staticClass: "d-flex flex-row" },
              [
                _c(
                  "ib-button-basic",
                  { staticClass: "mr-3", on: { click: _vm.save } },
                  [
                    _c("span", { staticClass: "font-outfit-regular" }, [
                      _vm._v(_vm._s(_vm.$t("save"))),
                    ]),
                  ]
                ),
                _c(
                  "ib-button-basic",
                  {
                    attrs: { color: "gray" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "font-outfit-regular" }, [
                      _vm._v(_vm._s(_vm.$t("discard"))),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }